export const ALARM_STATE = {
  ZERO: '0',
  ONE: '1',
} as const;

export type AlarmStateValue = (typeof ALARM_STATE)[keyof typeof ALARM_STATE];
